export default "__VITE_ASSET__Bkct6H5d__"